import { request } from "../index";
import { getCookieByName } from "../../utils";

export function createBranch(data) {
  return request({ url: "branches/", method: "POST", data });
}
export function updateBranch(id, data) {
  return request({ url: `branches/${id}/`, method: "PUT", data });
}
export function importDataWithCNPJ(cnpj, type) {
  return request({ url: "branches/search-cnpj/", params: { cnpj, type } });
}
export function getBranches() {
  return request({ url: "branches/" });
}
export function activeBranche(branch) {
  return request({ url: `branches/${branch.id}/active/`, method: "PUT" });
}
export function reactivateBranch(branchId) {
  return request({ url: `branches/${branchId}/switch_branch/`, method: "PUT" });
}
export function getCurrentBranchData() {
  const id = getCookieByName("branch_owner_id");
  return request({ url: `branches/${id}/` });
}
export function loadActivities() {
  const id = getCookieByName("branch_owner_id");
  return request({ url: `branches/${id}/load-activities/` });
}
export function getSecondaryCnae() {
  const id = getCookieByName("branch_owner_id");
  return request({ url: `branches/${id}/get-secondary-cnae/` });
}
export function editBranch(branchId, data) {
  return request({ url: `branches/${branchId}/`, method: "PUT", data })
}

export function deleteBranch(branchId) {
  return request({ url: `branches/${branchId}/switch_branch/`, method: "DELETE" });
}

export function stateLocationReq(params) {
  return request({ url: "state-location/", params });
}

export function getCnaes(params) {
  return request({ url: `cnaes/`, params })
}


// WEBPACK FOOTER //
// ./src/api/branches/index.js